// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const SandboxIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Sandbox/outline"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 22h8c5 0 7-2 7-7V9c0-5-2-7-7-7H8C3 2 1 4 1 9v6c0 5 2 7 7 7Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M22.65 9H20M3.65 9H1"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.334 9.667H9.667v4.666h4.667V9.667ZM7.917 17.833c.962 0 1.75-.787 1.75-1.75v-1.75h-1.75c-.963 0-1.75.788-1.75 1.75 0 .963.787 1.75 1.75 1.75ZM7.917 9.667h1.75v-1.75c0-.963-.788-1.75-1.75-1.75-.963 0-1.75.787-1.75 1.75 0 .962.787 1.75 1.75 1.75ZM14.333 9.667h1.75c.963 0 1.75-.788 1.75-1.75 0-.963-.787-1.75-1.75-1.75-.962 0-1.75.787-1.75 1.75v1.75Z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M16.083 17.833c.963 0 1.75-.787 1.75-1.75 0-.962-.787-1.75-1.75-1.75h-1.75v1.75c0 .963.788 1.75 1.75 1.75Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SandboxIcon;